module.exports = __webpack_public_path__ + "static/media/aumento_icon.62786b7d.JPG";